import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getLegislationLinkHealth = api(async function getLegislationLinkHealth({ ids }) {
    if (!ids?.length) return []
    return query(
        gql`
            query GetLegislationLinkHealth($ids: [String!]!) {
                getLegislationLinkHealth(ids: $ids)
            }
        `,
        { ids },
        { returns: "getLegislationLinkHealth" }
    )
})
